import { ActivatedRoute, Router } from "@angular/router";
import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { AddedServiceDataService } from '../../../../_dataservices/AddedServiceDataService';
import { AltProductImagePath, AppEventNames, CustomerTypeCodes, IVA } from "src/app-client/_appCommon/base/Constants";
import { BroadcastManager } from "../../../../_appCommon/base/BroadcastManager";
import { CaseStageDataService } from "../../../../_dataservices/CaseStageDataService";
import { ControllerBase } from "src/app-client/_appCommon/base/ControllerBase";
import { CurrencyTypeCode, CurrencyTypeInt, ItemPrices, ProductAdditionalServices, Service, ServiceImage, ServiceType, ServiceTypeLabel } from '../../../../_appCommon/base/AppInterfaceAndBaseClasses';
import { CustomerLevelDataService } from "../../../../_dataservices/CustomerLevelDataService";
import { CustomerTypeDataService } from "src/app-client/_dataservices/CustomerTypeDataService";
import { IntegerSpinnerComponent } from "src/shared/components/integer-spinner/integer-spinner.component";
import { OrderDetailDataService } from "../../../../_dataservices/OrderDetailDataService";
import { ProductDataService } from "../../../../_dataservices/ProductDataService";
import { ProductPriceListDataService } from '../../../../_dataservices/ProductPriceListDataService';
import { ShoppingCartDataService } from "src/app-client/_dataservices/ShoppingCartDataService";
import { UrlQueryDef } from "src/app-client/_appCommon/base/UrlQueryDef";
import { CasePurchasedOrdersDataService } from "src/app-client/_dataservices/CasePurchasedOrdersDataService";

@Component({
  selector: 'app-client-case-services',
  templateUrl: './case-services.component.html',
  styleUrls: ['./case-services.component.css'],
  providers: [ProductPriceListDataService, AddedServiceDataService, ProductDataService, CaseStageDataService, OrderDetailDataService, CustomerTypeDataService, CustomerLevelDataService]
})
export class CaseServicesComponent extends ControllerBase
{
  @Input() currentCustomer: any;
  @Input() productId: number;
  @Input() currentCase: any;
  @Output() hasComplexCaseEvent = new EventEmitter<boolean>();
  @Output() canCalculateUpgradeCost = new EventEmitter<boolean>();
  @ViewChild("additionalAlignerSpinner", { static: false }) additionalAlignerSpinner?: IntegerSpinnerComponent;
  @ViewChild('confirmDeleteCurrentCart') protected confirmDeleteCurrentCart: any;
  @ViewChild('createNewSetupDialog') protected createNewSetupDialog: any;

  public caseId: number;
  public emptyArray: boolean = false;

  public services = [
    {
      id: ServiceType.ComplexCase,
      title: ServiceTypeLabel.get(ServiceType.ComplexCase),
      description: 'Para casos con cierre de espacios de extracciones o quirúrgicos.',
      imgUrl: AltProductImagePath,
      checked: false,
      added: false,
      disabled: false,
      show: true,
      price: 0
    },

    {
      id: ServiceType.DentalMonitoring,
      title: ServiceTypeLabel.get(ServiceType.DentalMonitoring),
      description: 'Ofrece a tus pacientes una experiencia de vanguardia y alta tecnolog&iacute;a a trav&eacute;s de las ventajas que da el monitoreo remoto de su tratamiento Aliwell<sup>&#174;</sup> con DentalMonitoring<sup>&#174;</sup>.',
      imgUrl: AltProductImagePath,
      checked: false,
      added: false,
      disabled: false,
      show: true,
      price: 0
    },

    {
      id: ServiceType.AditionalAligners,
      title: ServiceTypeLabel.get(ServiceType.AditionalAligners),
      description: '',
      alignersQuantity: 1,
      lastAlignersQuantitySelected: 1,
      imgUrl: AltProductImagePath,
      checked: false,
      added: false,
      disabled: false,
      show: true,
      price: 0
    },
    {
      id: ServiceType.Upgrade,
      title: ServiceTypeLabel.get(ServiceType.Upgrade),
      description: 'Mejora tu paquete actual con los siguientes productos:',
      imgUrl: AltProductImagePath,
      checked: false,
      added: false,
      disabled: false,
      show: true,
      price: 0
    }
  ];

  private unsubscribe: Subject<void> = new Subject();

  public createNewSetup: boolean = false;
  public currencyType;
  public currentEntity: any;
  public currentNewStageId: number = -1;
  public currentStages = [];
  public isCustomerPRIME: boolean = false;
  public isSetupCompleted: boolean = false;
  public newSetupId: number = -1;
  public product: any;
  public totalAmount:number = 0;

  //Variables used to do the upgrade!
  public shoppingDiscount: any;
  public hasShoppingDiscount: boolean = false;
  public upgradeProduct: any;
  public products = [];
  @Output() productsReadyEvent = new EventEmitter<any>();

  constructor(
    private addedServiceDataService: AddedServiceDataService,
    private caseStageDataService: CaseStageDataService,
    private orderDetailDataService: OrderDetailDataService,
    private casePurchasedOrdersDataService: CasePurchasedOrdersDataService,
    private productDataService: ProductDataService,
    private router: Router,
    private shoppingCartDataService: ShoppingCartDataService,
    private customerLevelDataService: CustomerLevelDataService,
    private customerTypeDataService: CustomerTypeDataService,
    protected route: ActivatedRoute,
  )
  {
    super();
  }

  ngOnInit(): void
  {
    this.route.paramMap.subscribe(params =>
    {
      this.caseId = +params.get('id');
    });

    this.getProduct();
    this.getCustomerType();
    this.currencyType = CurrencyTypeCode.get(CurrencyTypeInt.MXN);

    this.addedServiceDataService.get(this.getQueryDefForGetAllAddedServices())
      .subscribe(response =>
      {
        this.setServiceData(response.rows);
      });

    BroadcastManager.Instance.on(AppEventNames.onCompleteSetup)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(([e]) =>
      {
        if (e[0])
        {
          this.isSetupCompleted = true;
          this.newSetupId = e[0];
        }
      });
  }

  ngOnDestroy(): void
  {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private setServiceData(servicesAdded: any): void
  {
    if(servicesAdded)
    {
      servicesAdded.forEach(serviceAdded =>
      {

        if (serviceAdded.serviceId != ServiceType.AditionalAligners && serviceAdded.serviceId != ServiceType.Upgrade)
        {
          this.services.find(x => x.title == ServiceTypeLabel.get(serviceAdded.serviceId)).added = true;
        }
      });
    }
  }

  public onSelectService(): void
  {
    this.totalAmount = 0;
    this.onSelectUpgrade();
    this.services.forEach(item =>
    {
      if (item.alignersQuantity && item.checked)
      {
        this.totalAmount += item.price * item.alignersQuantity;
      }
      else
      {
        if (item.checked)
        {
          this.totalAmount += <number>item.price;
        }
      }
    });
  }

  public onAddService(item: any): void
  {
    if(!item.checked)
    {
      this.services.find(x => x == item).checked = true;
      this.onSelectService();
    }
  }

  public onSelectUpgrade():void
  {
    if (this.services.find(x => x.id == ServiceType.Upgrade && x.checked == true))
    {
      let isUpgrade = this.services.find(x => x.id == ServiceType.Upgrade);
      if (isUpgrade.checked == true)
      {
        this.setInfoAlert("Cuando se hace un upgrade, los demás servicios no serán tomados en cuenta");
        this.services.forEach(service =>
        {
          if (service.id != ServiceType.Upgrade)
          {
            service.checked = false;
            service.disabled = true;
          }
        });
      }
    }
    else
    {
      this.services.forEach(service =>
      {
        if (service.id != ServiceType.Upgrade)
        {
          service.disabled = false;
        }
      });
    }
  }

  private getQueryDefForGetAllAddedServices(): UrlQueryDef
  {
    let queryDef = new UrlQueryDef;

    queryDef.filter = `CustomerId eq ${this.currentCustomer.id} and CaseId eq ${this.caseId}`;

    return queryDef;
  }

  private getQueryDefForGetAll(): UrlQueryDef
  {
    let queryDef = new UrlQueryDef;

    queryDef.filter = `CustomerTypeId eq ${this.currentCustomer.customerTypeId} and ProductId eq ${this.productId}`;

    return queryDef;
  }

  public countAdditionalAlignerChanged(event: any): void
  {
    let service = this.services[2];

    service.alignersQuantity = parseInt(event);
    if(service.checked)
    {
      event > service.lastAlignersQuantitySelected
        ? this.totalAmount += service.price
        : this.totalAmount -= service.price;

      service.lastAlignersQuantitySelected = event;
    }
  }

  public onClickProcessPurchase(): void
  {
    let servicesAdded = this.services.filter(x => x.checked == true);

    if(servicesAdded.length == 0)
    {
      this.setInfoAlert("Selecciona un servicio antes de continuar");
      return;
    }

    if(this.shoppingCartDataService.getCountItems() > 0)
    {
      this.confirmDeleteCurrentCart.show = true;
    }
    else
    {
      this.onPreProcessPurchase();
    }
  }

  public onProcessPurchase(): void
  {
    this.shoppingCartDataService.onClearItems();
    let servicesAdded = this.services.filter(x => x.checked == true);

    if(servicesAdded.length > 0)
    {
      servicesAdded.forEach( service =>
      {
        let itemPrices: ItemPrices =
        {
          price: service.alignersQuantity ? service.alignersQuantity * service.price : service.price,
          subtotal: service.price / (1 + IVA),
          shoppingDiscount: null,
          totalTax: (service.price / (1 + IVA)) * IVA
        };

        let additionalServices: ProductAdditionalServices =
        {
          addDentalMonitoring: service.id != ServiceType.DentalMonitoring ? false : true,
          addIsComplexCase: service.id != ServiceType.ComplexCase ? false : true,
          extraAlignersQuantity: service.id != ServiceType.AditionalAligners ? 0 : service.alignersQuantity,
        };

        let images: ServiceImage =
        {
          url: service.imgUrl,
        };

        let newService: Service = {
          id: this.productId,
          name: service.title,
          itemPrices: itemPrices,
          images: images,
          idSetup: this.newSetupId,
          serviceProductUpgrade: null,
          serviceType: service.id,
          additionalServices: additionalServices
        };
        if (service.id == ServiceType.Upgrade)
        {
          newService.serviceProductUpgrade = {...this.upgradeProduct, orderDetailId: this.currentCase.orderDetailId};
          newService.name = "Upgrade de producto: " + this.upgradeProduct.name;
        }
        this.shoppingCartDataService.onAddItem(newService, service.alignersQuantity ?? 1);
      });

      this.shoppingCartDataService.caseId = this.caseId;
      this.shoppingCartDataService.casePatientName = this.currentCase.patientFullName;

      this.router.navigate(['/ecommerce/checkout']);
    }
    else
    {
      this.setInfoAlert("Selecciona un servicio primero");
    }
  }

  private getProduct(): void
  {
    this.productDataService.getProductById(this.getQueryDefForGetById())
      .subscribe((response: any) =>
      {
        this.product = response;
        this.isComplexCaseAllowed(this.product);
        this.setPrices();
        //After getting the product we need to get the possible upgrade products
        this.getAllUpgradeProducts();
      }, (fail: any) =>
      {
        this.setWarningAlert(fail.error.message);
      });
  }

  private isComplexCaseAllowed(product : any)
  {
    if(!product.allowComplexCase)
    {
      this.services[0].show = false;
    }
  }

  public getCustomerType()
  {
    let queryDef: UrlQueryDef = new UrlQueryDef();

    if (this.currentCustomer.customerTypeId != null)
    {
      this.customerTypeDataService.getById(this.currentCustomer.customerTypeId, queryDef)
        .subscribe((response: any) =>
        {
          if (response.code == CustomerTypeCodes.PRIME)
          {
            this.isCustomerPRIME = true;
          }
        }, (fail: any) =>
        {

        });
    }
  }

  protected getQueryDefForGetById(): UrlQueryDef
  {
    let queryDef: UrlQueryDef = new UrlQueryDef();
    queryDef.addParam("Id", this.productId);
    queryDef.addParam("CustomerTypeId", this.currentCustomer.customerTypeId);
    return queryDef;
  }

  /**
   * Method used to set the product prices
   * */
  private setPrices(): void
  {
    //Array positions!
    //0 -> Complex
    //1 -> Dental
    //2 -> Aligners

    //Verify if has a ProductPriceList record
    let productPriceList = this.product.priceList.find(x => x.customerTypeId == this.currentCustomer.customerTypeId && !x.isDeleted);

    //Set price values!
    if (productPriceList != null)
    {
      this.services[0].price = <number>productPriceList.priceComplexCase;
      this.services[1].price = <number>productPriceList.priceExtraDentalMonitoring;
      this.services[2].price = <number>productPriceList.priceExtraAligner;
    }
    else
    {
      //Set default prices
      this.services[0].price = <number>this.product.basePriceComplexCase;
      this.services[1].price = <number>this.product.basePriceDentalMonitoring;
      this.services[2].price = <number>this.product.basePriceExtraAligner;
    }
    this.modifyServiceArray();
  }
  /**
   * Method used to continue with the purchase!
   * */
  public onPreProcessPurchase(): void
  {
    this.confirmDeleteCurrentCart.show = false;

    let isAdditionalAligners = false;

    //Check if there is a additional aligner in servicesAdded
    let servicesAdded = this.services.filter(x => x.checked == true);
    isAdditionalAligners = servicesAdded.any(x => x.id == ServiceType.AditionalAligners);

    this.onProcessPurchase();
  }

  /**
   * Method used to reset everything related to the additional aligners
   * */
  public onCancelChooseSetup(): void
  {
    this.createNewSetup = false;
    this.currentNewStageId = -1;
    this.newSetupId = -1;
    this.isSetupCompleted = false;
    this.currentStages = [];
    this.createNewSetupDialog.show = false;
  }

  /**
   * Method used to continue to the checkout
   * */
  public onContinueSetup(): void
  {
    this.onProcessPurchase();
  }


  public onGetQueryDefForCaseStages()
  {
    let queryDef = new UrlQueryDef();

    queryDef.filter = 'CaseId eq ' + this.caseId;
    queryDef.orderby = 'StageNumber';

    return queryDef;
  }

  /**
   * Method used to change the services array
   * This arrays is modified according to product and orderdetail information
   * */
  public modifyServiceArray(): void
  {
    let index;
    let body;
    let res = true;
    /**
     * Check product native properties!
     * */
    if (this.product.hasDentalMonitoring)
    {
      index = this.services.indexOf(this.services.find(x => x.id == ServiceType.DentalMonitoring));
      this.services[index].added = true;
    }

    if (this.product.hasUnlimitedAligners)
    {
      index = this.services.indexOf(this.services.find(x => x.id == ServiceType.AditionalAligners));
      this.services[index].added = true;
      index = this.services.indexOf(this.services.find(x => x.id == ServiceType.Upgrade));
      this.services[index].added = true;
    }
    body =
    {
      caseId: this.caseId,
      productId: this.product.id
    };

    /**
     * Check order detail properties!
     * */
    this.orderDetailDataService.checkAdditionalServices(body).subscribe((response: any) =>
    {
      if (response.addedDentalMonitoring)
      {
        index = this.services.indexOf(this.services.find(x => x.id == ServiceType.DentalMonitoring));
        this.services[index].added = true;
      }
      if (response.addedIsComplexCase)
      {
        index = this.services.indexOf(this.services.find(x => x.id == ServiceType.ComplexCase));
        this.services[index].added = true;
      }
      for (let i = 0; i < this.services.length; i++)
      {
        if (this.services[i].added == false)
        {
          res = false;
        }
      }
      if (res)
        this.emptyArray = true;
    }, (fail: any) =>
    {
      this.setWarningAlert(fail.error.message);
    });
  }
  /**
   * Get all of the products
   * The returned products are active and its type is plan
   * Also this products has a large number of aligners than the actual product
   * */
  public getAllUpgradeProducts(): void
  {
    this.productDataService.get(this.getQueryDefForGetAllProducts())
      .subscribe((response: any) =>
      {
        for (let i = 0; i < response.rows.length && !this.product.hasUnlimitedAligners; i++)
        {
          if (response.rows[i].alignersQuantity > this.product.alignersQuantity || response.rows[i].hasUnlimitedAligners)
          {
            this.products.push(response.rows[i]);
          }
        }
        this.getShoppingDiscount();//Check if the user has some discount
      }, (fail: any) =>
      {

      });
  }
  /**
   * Method used to return a querydef which filters products:
   * - Active products
   * - Plan type
   * */
  protected getQueryDefForGetAllProducts(): UrlQueryDef
  {
    let queryDef: UrlQueryDef = new UrlQueryDef();
    queryDef.filter = `IsActive eq ${true}`;
    queryDef.filter += ` and CategoryId eq ${1}`;//Verify which category we will show
    return queryDef;
  }
  /**
   * Method used to get the shopping discount and apply it to the prices
   * */
  private getShoppingDiscount(): void
  {
    let id = this.currentCustomer.customerLevelId;
    if (id != null)
    {
      this.customerLevelDataService.getCustomerLevelById(id)
        .subscribe((response: any) =>
        {
          if (parseFloat(response.shoppingDiscount) != 0 && !response.isDeleted)
          {
            this.shoppingDiscount = parseFloat(response.shoppingDiscount);
            this.hasShoppingDiscount = true;
          }
          else
          {
            this.shoppingDiscount = 0;
          }
          this.getPurchasedProductPrice();//Compute the product price
        }, (fail: any) =>
        {
          this.setWarningAlert(fail.error.message);
        });
    }
    else
    {
      this.shoppingDiscount = 0;
      this.getPurchasedProductPrice();
    }
  }

  private getPurchasedProductPrice()
  {
    let queryDef: UrlQueryDef = new UrlQueryDef();
    queryDef.addParam("caseId", this.caseId);
    queryDef.addParam("orderDetailId", this.currentCase.orderDetailId);
    this.casePurchasedOrdersDataService.getPurchasedOrderPaymentsForProduct(queryDef)
      .subscribe((response) =>
      {
        let currentPaidPrice = response;
        this.showCorrectPrice(currentPaidPrice);
        this.canCalculateUpgradeCost.emit(true);
      }, (fail) =>
      {
        this.canCalculateUpgradeCost.emit(false);
      });
  }
  /**
   * Add property finalPrice to the list of products
   *
   * */
  private showCorrectPrice(currentPaidPrice: number): void
  {
    let res: any;
    this.product.correctPrice = currentPaidPrice;
    for (let i = 0; i < this.products.length; i++)
    {
      this.products[i].correctPrice = this.getProductPrice(this.products[i]);
    }
    //Get difference
    for (let i = 0; i < this.products.length; i++)
    {
      res = 0;
      res = this.products[i].correctPrice - this.product.correctPrice;
      if (res < 0)
      {
        res = 0;
      }
      this.products[i].finalPrice = res.toFixed(2);
    }
    this.upgradeProduct = this.products.firstOrNull();
    if (this.upgradeProduct != null)
    {
      this.onSelectionUpgradeChange();
    }
    this.readyProducts();
  }
  /**
   * Method used to compute the product price.
   * */
  private getProductPrice(product: any): any
  {
    let productPrice;
    let tax;
    let totalTax;
    let subtotal;
    let finalPrice;
    let discount;
    let productPriceList = product.priceList.find(x => x.customerTypeId == this.currentCustomer.customerTypeId && !x.isDeleted);
    if (productPriceList)
    {
      productPrice = productPriceList.priceProduct;
      tax = productPriceList.tax;
      subtotal = tax != 0 ? productPrice : productPrice / (1 + IVA);
      discount = this.shoppingDiscount != 0 ? subtotal * this.shoppingDiscount : 0;
      subtotal = subtotal - discount;
      totalTax = subtotal * (tax != 0 ? tax : IVA);
      finalPrice = subtotal + totalTax;
    }
    else
    {
      productPrice = product.basePriceProduct;
      tax = product.baseTax;
      subtotal = tax != 0 ? productPrice : productPrice / (1 + IVA);
      discount = this.shoppingDiscount != 0 ? subtotal * this.shoppingDiscount : 0;
      subtotal = subtotal - discount;
      totalTax = subtotal * (tax != 0 ? tax : IVA);
      finalPrice = subtotal + totalTax;
    }
    return finalPrice;
  }

  /**
   * Method used to change the service price dinamically
   * */
  private onSelectionUpgradeChange()
  {
    this.services.find(x => x.id == ServiceType.Upgrade).price = this.upgradeProduct.finalPrice;
    this.onSelectService();
  }

  public readyProducts(): void
  {
    this.productsReadyEvent.emit(this.products);
  }
}
